module.exports = __webpack_public_path__ + "img/service_img1.dd256ff3.png";